export const humanizeVariableName = (name: string): string => {
  const words = name
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  if (words.length === 0) {
    return name
  }
  return words.charAt(0).toUpperCase() + words.slice(1)
}
